module.exports = __webpack_public_path__ + "static/assets/670b1699f94bdcb72d9bfea5da334337.png";